<template>
  <CCard>
    <CCardHeader>
      <strong style="line-height: 2.3">온실 추천 정보</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol col="12" md="4">
          <div>
            <h6 class="text-center">
              VPD
              <div
                class="btn btn-sm text-white"
                :class="vpd.color"
                style="padding-top: 2px; padding-bottom: 2px"
              >
                {{ vpd.label }}
              </div>
              {{ vpd.value }} (권장 0.5~1.2kPa)
            </h6>
            <div ref="vpdChart" style="width: 100%; height: 250px">chart</div>
          </div>
        </CCol>
        <CCol col="12" md="4">
          <div>
            <h6 class="text-center">
              HD
              <div
                class="btn btn-sm text-white"
                :class="hd.color"
                style="padding-top: 2px; padding-bottom: 2px"
              >
                {{ hd.label }}
              </div>
              {{ hd.value }}
              (권장 3~8 g/m³)
            </h6>
            <div ref="hdChart" style="width: 100%; height: 250px">chart</div>
          </div>
        </CCol>

        <CCol col="12" md="4">
          <ul class="scc-timeline-list">
            <li>
              <div class="scc-timeline-icon" style="background-color: #ffbb00">
                <i class="fa fa-sun-o" aria-hidden="true"></i>
              </div>
              <div class="scc-timeline-time font-weight-bold">온도</div>
              <div class="scc-timeline-content">
                <p>
                  표준 토마토 환경 모델에<i
                    class="label bg-color-green-dark scc-rounded"
                    >적절</i
                  >한 수준입니다.
                </p>
                <p>
                  온실내 온도가
                  <i
                    class="label bg-color-green-dark scc-rounded"
                    aria-hidden="true"
                  >
                    적절</i
                  >하여 기존 제어방식을 유지합니다.
                </p>
              </div>
            </li>
            <li>
              <div class="scc-timeline-icon" style="background-color: #0044ff">
                <i class="fa fa-tint" aria-hidden="true"></i>
              </div>
              <div class="scc-timeline-time font-weight-bold">습도</div>
              <div class="scc-timeline-content">
                <p>
                  표준 토마토 환경 모델에<i
                    class="label bg-color-green-dark scc-rounded"
                    >적절</i
                  >한 수준입니다.
                </p>
                <p>
                  온실내 습도가<i class="label bg-color-green-dark scc-rounded" aria-hidden="true"
                    >적절</i
                  >하여 기존 제어방식을 유지합니다.
                </p>
              </div>
            </li>
          </ul>
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import store from "@/store";
import core from "@/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import MixinsInEnvSensor from "@/mixins/in-env-sensor";

export default {
  name: "InEnvRecommCard",
  components: {},
  mixins: [MixinsInEnvSensor()],
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          initFlag: false,
          inEnvList: [],
        };
      },
    },
  },
  data() {
    return {
      app: store.state.app,
      vpd: {
        label: "",
        color: "",
        value: "",
        chart: null,
      },
      hd: {
        label: "",
        color: "",
        value: "",
        chart: null,
      },
    };
  },
  created() {},
  watch: {
    "properties.initFlag"(val) {
      this.properties.initFlag = false;
      if (val) {
        this.init();
      }
    },
    "properties.inEnvList"() {
      this.redraw();
    },
  },
  methods: {
    init() {
      if (this.vpd.chart == null) {
        this.createVpdChart();
      }
      if (this.hd.chart == null) {
        this.createHdChart();
      }
      this.vpd.chart.data = [];
      this.hd.chart.data = [];
    },
    redraw() {
      if (this.vpd.chart == null) {
        this.createVpdChart();
      }
      if (this.hd.chart == null) {
        this.createHdChart();
      }
      const list = this.properties.inEnvList;

      let lastDate = core.date.instance();
      const dataList = this.getFilterDataList(list, lastDate);
      const avgList = this.getAvgDataList(dataList);
      if (dataList.length > 0) {
        this.emptyFlag = false;

        const sensor = dataList[dataList.length - 1];
        const transpiration = sensor.transpiration;
        //console.log(transpiration);
        this.vpd.label = transpiration.vpdLabel;
        this.vpd.color = transpiration.vpdColor;
        this.vpd.value = sensor.vpd;
        this.hd.label = transpiration.hdLabel;
        this.hd.color = transpiration.hdColor;
        this.hd.value = sensor.hd;

        this.temp = sensor.temp.toFixed(2);
        this.humidity = sensor.humidity.toFixed(2);

        let recommendTemp = transpiration.recommend.temp;
        let recommendHumidity = transpiration.recommend.humidity;

        const hd = this.hd.value;
        if (hd < 3) {
          this.recommendHtml = `온실 내 습도가 <span class="label bg-color-red">과다</span>하니
            온도를 ${recommendTemp}도 까지 올리거나 습도를 ${recommendHumidity}%까지 낮추기위해 아래와 같은 온실제어를 추천드립니다.
             `;
        } else if (hd > 8) {
          this.recommendHtml = `온실 내 습도가 <span class="label bg-color-orange">부족</span>하니
            온도를 ${recommendTemp}도 까지 낮추거나 습도를 ${recommendHumidity}%까지 올리기위해 아래와 같은 온실제어를 추천드립니다.
             `;
        } else {
          this.recommendHtml = `온실 내 습도가 <span class="label bg-color-green-dark">적절</span>하여 <strong>현재 온실제어</strong> 상황을 유지합니다.`;
        }
      } else {
        this.emptyFlag = true;
        this.vpd.label = "";
        this.vpd.color = "";
        this.vpd.value = "";
        this.hd.label = "";
        this.hd.class = "";
        this.hd.value = "";
        this.recommendHtml = "추천할 데이터가 없습니다.";
      }
      if (this.vpd.chart != null) {
        this.vpd.chart.data = dataList;
      } else {
        console.log("is not ready vpd chart");
      }
      if (this.hd.chart != null) {
        this.hd.chart.data = dataList;
      } else {
        console.log("is not ready hd chart");
      }
    },
    createVpdChart() {
      const $el = this.$refs.vpdChart;
      const chart = core.amchart.createXYDateChart($el);
      const dateFieldName = "date";
      let series = core.amchart.createLineSeries(
        chart,
        "vpd",
        dateFieldName,
        "실시간",
        null,
        "kPa",
      );

      const valueAxis = chart.customItem.valueAxis;

      // 범위 오류
      core.amchart.addLineChartRange(valueAxis, series, -9999, 0, "#000");
      // 부족
      core.amchart.addLineChartRange(valueAxis, series, 0, 0.5, "#d7810a");
      // 적합
      core.amchart.addLineChartRange(valueAxis, series, 0.5, 1.2, "#517951");
      // 과다
      core.amchart.addLineChartRange(valueAxis, series, 1.2, 9999, "#cd153f");

      series.tooltip.pointerOrientation = "vertical";
      series.tooltip.background.cornerRadius = 10;
      series.tooltip.background.fillOpacity = 1;
      series.tooltip.label.padding(5, 10, 5, 10);
      series.tooltip.label.fill = am4core.color("#000");
      series.tooltip.getFillFromObject = false;
      series.tooltip.background.fill = am4core.color("#fff");
      series = null;

      series = core.amchart.createColumnSeries(
        chart,
        "avgVpd",
        dateFieldName,
        "누적",
        null,
        "kPa",
      );

      core.amchart.addColumnChartAdapter(series, (value) => {
        if (0 <= value && value < 0.5) {
          return am4core.color("#d7810a");
        } else if (0.5 <= value && value < 1.2) {
          return am4core.color("#517951");
        } else if (1.2 <= value) {
          return am4core.color("#cd153f");
        } else {
          return am4core.color("#000");
        }
      });

      series.tooltip.pointerOrientation = "vertical";
      series.tooltip.background.cornerRadius = 10;
      series.tooltip.background.fillOpacity = 1;
      series.tooltip.label.padding(5, 10, 5, 10);
      series.tooltip.label.fill = am4core.color("#000");
      series.tooltip.getFillFromObject = false;
      series.tooltip.background.fill = am4core.color("#fff");
      series = null;

      const scrollbarX = new am4core.Scrollbar();
      chart.cursor = new am4charts.XYCursor();
      chart.scrollbarX = scrollbarX;

      chart.data = null;
      this.vpd.chart = chart;
    },
    createHdChart() {
      const $el = this.$refs.hdChart;
      const chart = core.amchart.createXYDateChart($el);

      const dateFieldName = "date";
      let series = core.amchart.createLineSeries(
        chart,
        "hd",
        dateFieldName,
        "실시간",
        null,
        "kPa",
      );

      const valueAxis = chart.customItem.valueAxis;

      // 범위 오류
      core.amchart.addLineChartRange(valueAxis, series, -9999, 0, "#000");
      // 부족
      core.amchart.addLineChartRange(valueAxis, series, 0, 3, "#d7810a");
      // 적합
      core.amchart.addLineChartRange(valueAxis, series, 3, 8, "#517951");
      // 과다
      core.amchart.addLineChartRange(valueAxis, series, 8, 9999, "#cd153f");

      series.tooltip.pointerOrientation = "vertical";
      series.tooltip.background.cornerRadius = 10;
      series.tooltip.background.fillOpacity = 1;
      series.tooltip.label.padding(5, 10, 5, 10);
      series.tooltip.label.fill = am4core.color("#000");
      series.tooltip.getFillFromObject = false;
      series.tooltip.background.fill = am4core.color("#fff");
      series = null;

      series = core.amchart.createColumnSeries(
        chart,
        "avgHd",
        dateFieldName,
        "누적",
        null,
        "kPa",
      );

      core.amchart.addColumnChartAdapter(series, (value) => {
        if (0 <= value && value < 3) {
          return am4core.color("#d7810a");
        } else if (3 <= value && value < 8) {
          return am4core.color("#517951");
        } else if (8 <= value) {
          return am4core.color("#cd153f");
        } else {
          return am4core.color("#000");
        }
      });

      series.tooltip.pointerOrientation = "vertical";
      series.tooltip.background.cornerRadius = 10;
      series.tooltip.background.fillOpacity = 1;
      series.tooltip.label.padding(5, 10, 5, 10);
      series.tooltip.label.fill = am4core.color("#000");
      series.tooltip.getFillFromObject = false;
      series.tooltip.background.fill = am4core.color("#fff");
      series = null;

      const scrollbarX = new am4core.Scrollbar();
      chart.cursor = new am4charts.XYCursor();
      chart.scrollbarX = scrollbarX;

      chart.data = null;
      this.hd.chart = chart;
    },
  },
};
</script>
